<template>
    <div class="base-date-management">
      <h2 class="page-title">基准日期管理</h2>
  
      <!-- 搜索区域 -->
      <el-card class="search-card">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="日期名称">
            <el-input v-model="searchForm.name" placeholder="请输入日期名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="启用" :value="true"></el-option>
              <el-option label="停用" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
  
      <!-- 操作按钮区域 -->
      <div class="operation-container">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增基准日期</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="multipleSelection.length === 0" @click="handleBatchDelete">批量删除</el-button>
      </div>
  
      <!-- 表格区域 -->
      <el-table
        ref="dateTable"
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="name"
          label="日期名称"
          min-width="150"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="code"
          label="唯一标识"
          width="120"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="description"
          label="描述信息"
          min-width="200"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="category"
          label="分类"
          width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.category === '就诊' ? 'primary' : scope.row.category === '住院' ? 'success' : 'warning'">
              {{ scope.row.category }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="170">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="120">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-text="启用"
              inactive-text="停用"
              @change="handleStatusChange(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
  
      <!-- 新增/编辑对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
        <el-form :model="dateForm" :rules="dateRules" ref="dateForm" label-width="100px">
          <el-form-item label="日期名称" prop="name">
            <el-input v-model="dateForm.name" placeholder="请输入日期名称"></el-input>
          </el-form-item>
          <el-form-item label="唯一标识" prop="code">
            <el-input v-model="dateForm.code" placeholder="请输入唯一标识" :disabled="dialogType === 'edit'"></el-input>
            <div class="form-tip" v-if="dialogType === 'add'">系统唯一标识，用于程序调用，添加后不可修改</div>
          </el-form-item>
          <el-form-item label="分类" prop="category">
            <el-select v-model="dateForm.category" placeholder="请选择分类" style="width: 100%">
              <el-option label="就诊" value="就诊"></el-option>
              <el-option label="住院" value="住院"></el-option>
              <el-option label="手术" value="手术"></el-option>
              <el-option label="产科" value="产科"></el-option>
              <el-option label="生殖" value="生殖"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述信息" prop="description">
            <el-input type="textarea" v-model="dateForm.description" :rows="4" placeholder="请输入描述信息"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-switch v-model="dateForm.status" active-text="启用" inactive-text="停用"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'BaseDateManagement',
    data() {
      return {
        // 搜索表单
        searchForm: {
          name: '',
          status: ''
        },
        
        // 表格数据
        tableData: [],
        loading: false,
        multipleSelection: [],
        
        // 分页相关
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        
        // 对话框相关
        dialogVisible: false,
        dialogTitle: '新增基准日期',
        dialogType: 'add', // add: 新增, edit: 编辑
        
        // 基准日期表单
        dateForm: {
          id: '',
          name: '',
          code: '',
          description: '',
          category: '',
          status: true
        },
        
        // 表单验证规则
        dateRules: {
          name: [
            { required: true, message: '请输入日期名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入唯一标识', trigger: 'blur' },
            { pattern: /^[a-z_][a-z0-9_]*$/, message: '格式为小写字母、数字、下划线，且必须以字母或下划线开头', trigger: 'blur' }
          ],
          category: [
            { required: true, message: '请选择分类', trigger: 'change' }
          ],
          description: [
            { max: 200, message: '描述信息不能超过200个字符', trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      this.fetchData();
    },
    methods: {
      // 获取数据
      fetchData() {
        this.loading = true;
        
        // 模拟API请求延迟
        setTimeout(() => {
          // 模拟基准日期数据
          const mockData = [
            {
              id: '1001',
              name: '入组时间',
              code: 'enrollment_date',
              description: '患者正式加入医疗项目或计划的日期，通常作为随访起点',
              category: '就诊',
              createTime: '2023-01-15 10:25:36',
              status: true
            },
            {
              id: '1002',
              name: '购买日',
              code: 'purchase_date',
              description: '患者购买医疗服务或产品的日期',
              category: '其他',
              createTime: '2023-01-17 11:35:22',
              status: true
            },
            {
              id: '1003',
              name: '手术日',
              code: 'surgery_date',
              description: '患者接受手术治疗的日期，常作为术后随访的起点',
              category: '手术',
              createTime: '2023-01-18 14:20:47',
              status: true
            },
            {
              id: '1004',
              name: '出生日期',
              code: 'birth_date',
              description: '患者或新生儿的出生日期，用于计算年龄和生长发育监测',
              category: '产科',
              createTime: '2023-01-20 09:15:33',
              status: true
            },
            {
              id: '1005',
              name: '首次促排卵',
              code: 'first_ovulation',
              description: '患者首次接受促排卵治疗的日期，用于辅助生殖技术流程',
              category: '生殖',
              createTime: '2023-01-22 16:40:19',
              status: true
            },
            {
              id: '1006',
              name: '首次治疗日',
              code: 'first_treatment',
              description: '患者首次接受特定治疗的日期，用作治疗效果评估的基线',
              category: '就诊',
              createTime: '2023-01-25 10:52:41',
              status: true
            },
            {
              id: '1007',
              name: '分娩日',
              code: 'delivery_date',
              description: '孕妇分娩的日期，是产后随访的起点',
              category: '产科',
              createTime: '2023-01-28 11:05:37',
              status: true
            },
            {
              id: '1008',
              name: '满月日',
              code: 'full_month',
              description: '新生儿出生后满一个月的日期，通常安排第一次儿保随访',
              category: '产科',
              createTime: '2023-01-30 14:18:26',
              status: true
            },
            {
              id: '1009',
              name: '移植日',
              code: 'transplant_date',
              description: '胚胎移植或器官移植的日期，作为后续监测的起点',
              category: '生殖',
              createTime: '2023-02-01 09:30:54',
              status: true
            },
            {
              id: '1010',
              name: '出院日',
              code: 'discharge_date',
              description: '患者出院的日期，用于出院后随访管理',
              category: '住院',
              createTime: '2023-02-03 15:43:22',
              status: true
            },
            {
              id: '1011',
              name: '治疗结束日',
              code: 'end_treatment',
              description: '患者完成特定治疗方案的日期，标志治疗阶段的结束',
              category: '就诊',
              createTime: '2023-02-05 10:12:39',
              status: true
            },
            {
              id: '1012',
              name: '复诊日',
              code: 'follow_up_date',
              description: '患者复诊的日期，用于后续治疗计划的制定',
              category: '就诊',
              createTime: '2023-02-08 11:25:47',
              status: true
            },
            {
              id: '1013',
              name: '进周日',
              code: 'week_entry',
              description: '孕妇妊娠进入新的孕周的日期，用于孕期监测',
              category: '产科',
              createTime: '2023-02-10 14:36:28',
              status: true
            },
            {
              id: '1014',
              name: '取卵日',
              code: 'egg_retrieval',
              description: '在辅助生殖技术中，女性取卵的日期',
              category: '生殖',
              createTime: '2023-02-12 09:48:33',
              status: true
            },
            {
              id: '1015',
              name: '报告查询时间',
              code: 'report_query_time',
              description: '检验或检查报告可供查询的时间点',
              category: '其他',
              createTime: '2023-02-15 16:54:19',
              status: true
            },
            {
              id: '1016',
              name: '报告解读日',
              code: 'report_interpretation',
              description: '医生为患者解读检查报告的日期',
              category: '就诊',
              createTime: '2023-02-18 10:07:36',
              status: false
            },
            {
              id: '1017',
              name: '开单日',
              code: 'order_date',
              description: '医生为患者开具检查或处方的日期',
              category: '就诊',
              createTime: '2023-02-20 11:18:44',
              status: true
            },
            {
              id: '1018',
              name: '开单缴费时间',
              code: 'payment_time',
              description: '患者完成医疗服务缴费的时间',
              category: '其他',
              createTime: '2023-02-22 15:29:57',
              status: true
            },
            {
              id: '1019',
              name: '穿刺执行时间',
              code: 'puncture_time',
              description: '进行穿刺类操作的具体时间',
              category: '手术',
              createTime: '2023-02-25 09:42:18',
              status: true
            },
            {
              id: '1020',
              name: '预约复诊日',
              code: 'appointment_followup',
              description: '患者预约的下次复诊日期',
              category: '就诊',
              createTime: '2023-02-28 14:53:32',
              status: true
            },
            {
              id: '1021',
              name: '取消复诊日',
              code: 'cancel_followup',
              description: '患者取消已预约复诊的日期',
              category: '就诊',
              createTime: '2023-03-02 10:04:46',
              status: false
            },
            {
              id: '1022',
              name: '入院开单日',
              code: 'admission_order',
              description: '医生为患者开具住院单的日期',
              category: '住院',
              createTime: '2023-03-05 11:15:29',
              status: true
            },
            {
              id: '1023',
              name: '入院登记日',
              code: 'admission_registration',
              description: '患者完成住院登记的日期',
              category: '住院',
              createTime: '2023-03-08 15:36:47',
              status: true
            },
            {
              id: '1024',
              name: '预约入院日',
              code: 'appointment_admission',
              description: '患者预约入院的日期',
              category: '住院',
              createTime: '2023-03-10 09:47:58',
              status: true
            },
            {
              id: '1025',
              name: '取消入院日',
              code: 'cancel_admission',
              description: '患者取消预约入院的日期',
              category: '住院',
              createTime: '2023-03-12 16:08:24',
              status: false
            },
            {
              id: '1026',
              name: '入院日',
              code: 'admission_date',
              description: '患者实际入院的日期，开始住院治疗',
              category: '住院',
              createTime: '2023-03-15 10:19:37',
              status: true
            }
          ];
          
          this.tableData = mockData;
          this.pagination.total = mockData.length;
          this.loading = false;
        }, 800);
      },
      
      // 搜索
      handleSearch() {
        this.pagination.currentPage = 1;
        
        // 实际项目中这里应该调用筛选API
        this.loading = true;
        setTimeout(() => {
          let filteredData = [...this.tableData];
          
          if (this.searchForm.name) {
            filteredData = filteredData.filter(item => 
              item.name.includes(this.searchForm.name) || 
              item.code.includes(this.searchForm.name) ||
              (item.description && item.description.includes(this.searchForm.name))
            );
          }
          
          if (this.searchForm.status !== '') {
            filteredData = filteredData.filter(item => item.status === this.searchForm.status);
          }
          
          this.tableData = filteredData;
          this.pagination.total = filteredData.length;
          this.loading = false;
          
          this.$message({
            type: 'success',
            message: '搜索完成'
          });
        }, 500);
      },
      
      // 重置搜索
      resetSearch() {
        this.$refs.searchForm.resetFields();
        this.fetchData();
      },
      
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      
      // 分页大小改变
      handleSizeChange(val) {
        this.pagination.pageSize = val;
        this.fetchData();
      },
      
      // 当前页改变
      handleCurrentChange(val) {
        this.pagination.currentPage = val;
        this.fetchData();
      },
      
      // 状态改变
      handleStatusChange(row) {
        const statusText = row.status ? '启用' : '停用';
        this.$message({
          message: `已${statusText}【${row.name}】基准日期`,
          type: 'success'
        });
      },
      
      // 新增基准日期
      handleAdd() {
        this.dialogType = 'add';
        this.dialogTitle = '新增基准日期';
        this.dateForm = {
          id: '',
          name: '',
          code: '',
          description: '',
          category: '',
          status: true
        };
        this.dialogVisible = true;
        // 等待DOM更新后设置焦点
        this.$nextTick(() => {
          if (this.$refs.dateForm) {
            this.$refs.dateForm.clearValidate();
          }
        });
      },
      
      // 编辑基准日期
      handleEdit(row) {
        this.dialogType = 'edit';
        this.dialogTitle = '编辑基准日期';
        this.dateForm = JSON.parse(JSON.stringify(row)); // 深拷贝
        this.dialogVisible = true;
        // 等待DOM更新后设置焦点
        this.$nextTick(() => {
          if (this.$refs.dateForm) {
            this.$refs.dateForm.clearValidate();
          }
        });
      },
      
      // 删除基准日期
      handleDelete(row) {
        this.$confirm(`确认删除基准日期【${row.name}】吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟API删除操作
          setTimeout(() => {
            this.tableData = this.tableData.filter(item => item.id !== row.id);
            this.pagination.total = this.tableData.length;
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }, 500);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      
      // 批量删除
      handleBatchDelete() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请至少选择一个基准日期');
          return;
        }
        
        const names = this.multipleSelection.map(item => item.name).join('、');
        this.$confirm(`确认批量删除选中的 ${this.multipleSelection.length} 个基准日期吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟API删除操作
          setTimeout(() => {
            const ids = this.multipleSelection.map(item => item.id);
            this.tableData = this.tableData.filter(item => !ids.includes(item.id));
            this.pagination.total = this.tableData.length;
            this.$message({
              type: 'success',
              message: `成功删除 ${this.multipleSelection.length} 个基准日期!`
            });
            this.multipleSelection = [];
          }, 500);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      
      // 提交表单
      submitForm() {
        this.$refs.dateForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            
            // 模拟API保存操作
            setTimeout(() => {
              if (this.dialogType === 'edit') {
                // 编辑模式
                const index = this.tableData.findIndex(item => item.id === this.dateForm.id);
                if (index !== -1) {
                  this.tableData[index] = JSON.parse(JSON.stringify(this.dateForm));
                }
                this.$message({
                  message: '修改成功！',
                  type: 'success'
                });
              } else {
                // 新增模式
                const newDate = JSON.parse(JSON.stringify(this.dateForm));
                newDate.id = 'D' + new Date().getTime();
                newDate.createTime = this.formatDateTime(new Date());
                this.tableData.unshift(newDate);
                this.pagination.total = this.tableData.length;
                this.$message({
                  message: '添加成功！',
                  type: 'success'
                });
              }
              
              this.dialogVisible = false;
              this.loading = false;
            }, 600);
          } else {
            return false;
          }
        });
      },
      
      // 格式化日期时间
      formatDateTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }
  }
  </script>
  
  <style scoped>
  .base-date-management {
    padding: 15px;
  }
  
  .page-title {
    margin-bottom: 20px;
    color: #303133;
    font-weight: 600;
    font-size: 20px;
  }
  
  .search-card {
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }
  
  .operation-container {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
  }
  
  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
  
  .form-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
    line-height: 1.4;
  }
  
  .el-tag {
    margin-right: 5px;
  }
  
  /* 表格样式微调 */
  .el-table .cell {
    line-height: 1.5;
  }
  
  /* 表格内标签颜色定义 */
  .el-tag.el-tag--warning {
    background-color: #fdf6ec;
    border-color: #fbecda;
    color: #e6a23c;
  }
  
  .el-tag.el-tag--primary {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409EFF;
  }
  
  .el-tag.el-tag--success {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  
  /* 对话框样式 */
  .el-dialog__body {
    padding-top: 10px;
  }
  
  .dialog-footer {
    text-align: right;
  }
  
  /* 响应式调整 */
  @media (max-width: 768px) {
    .el-form-item {
      margin-bottom: 18px;
    }
  }
  </style>